import { AnimatePresence } from "framer-motion";
import { t } from "i18next";
import { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { mutate } from "swr";

import Chevron from "@/assets/icons/chevron.svg?react";
import Copy from "@/assets/icons/copy.svg?react";
// import QuestionMark from "@/assets/icons/help-circle.svg?react";
import EVM from "@/assets/icons/networks/evm.svg?react";
import UserIcon from "@/assets/icons/user.svg?react";
// import { HAPI_URL } from "@/constants";
import { ColoredNetworkIconMap } from "@/constants/map";
import { useStore } from "@/hooks/store";
import { useOnClickOutside } from "@/hooks/useOnClickOutside";
import { API_ROUTES } from "@/interfaces/api";
import { MIXPANEL_EVENTS } from "@/interfaces/mixpanel";
import { Network } from "@/interfaces/network";
// import { useModalContext } from "@/providers/modal-provider/context";
import { APP_ROUTES } from "@/routes/constants";
import { logger } from "@/services/config/mixpanel";
import { addressesVariants } from "@/theme/transitions";
import { ApiVersion, apiVersion, cropString } from "@/utils";
import { copy } from "@/utils/copy";

import styles from "./styles";
import { ToastService } from "../ToastService";

export const Header = () => {
  const node = useRef<HTMLDivElement>(null);

  const navigate = useNavigate();
  // useModalContext();
  const user = useStore((store) => store.user);
  const [show, setShow] = useState<boolean>(false);
  const handleClick = () => setShow(!show);

  useOnClickOutside(node, show ? handleClick : null);

  const wallets = [
    { title: "EVM", account: user.evmAccount, icon: <EVM /> },
    { title: Network.TON, account: user.tonAccount, icon: ColoredNetworkIconMap.TON },
    { title: Network.SOLANA, account: user.solanaAccount, icon: ColoredNetworkIconMap.SOLANA },
    { title: Network.NEAR, account: user.nearAccount, icon: ColoredNetworkIconMap.NEAR },
    { title: Network.STELLAR, account: user.stellarAccount, icon: ColoredNetworkIconMap.STELLAR },
  ];

  const handleCopy = async (account: string, network: string) => {
    const success = await copy(account);
    if (success) {
      const icon = ColoredNetworkIconMap[network as Network] || <EVM />;
      ToastService.simple({ icon, text: t("Messages.Copied", { network }) });
    } else {
      ToastService.simple({ type: "error", text: t("Messages.SomethingWentWrong") });
    }
  };

  const isDashboard = location.pathname === APP_ROUTES.DASHBOARD;
  const isAirdrop = location.pathname === APP_ROUTES.AIRDROPS;
  const address = apiVersion === ApiVersion.v1 ? user.nearAccount : user.tonAccount;

  return (
    <styles.Container>
      {
        (isDashboard || isAirdrop) && (
          <styles.BackAction
            className="back-action"
            onClick={() => {
              navigate(APP_ROUTES.HOME);
              if (!user.totalScore) {
                mutate(`${API_ROUTES.USER}/${address}`);
              }
            }}
          >
            <Chevron />
          </styles.BackAction>
        )
        // <QuestionMark
        //   onClick={() => {
        //     logger.trackEvent(MIXPANEL_EVENTS.OPEN_HELPER_CENTER, { link: HAPI_URL });
        //     modal.faq.openModal();
        //   }}
        // />
      }
      <div className="addressBlock" ref={node}>
        <styles.Address onClick={handleClick}>
          {cropString({ query: address || "" })}
          <Chevron />
        </styles.Address>
        <AnimatePresence>
          {show && (
            <styles.Addresses initial="initial" animate="animate" exit="exit" variants={addressesVariants}>
              {wallets
                .filter(({ account }) => !!account)
                .map(
                  ({ title, account, icon }) =>
                    account && (
                      <div key={title}>
                        {icon}
                        <span>{title}</span>
                        <span>{cropString({ query: account, step: 6 })}</span>
                        <Copy onClick={() => handleCopy(account, title)} />
                      </div>
                    ),
                )}
            </styles.Addresses>
          )}
        </AnimatePresence>
      </div>
      {!isDashboard || isAirdrop ? (
        <UserIcon
          className="user-icon"
          onClick={() => {
            if (isDashboard) return;
            logger.trackEvent(MIXPANEL_EVENTS.DASHBOARD);
            navigate(APP_ROUTES.DASHBOARD);
          }}
        />
      ) : null}
    </styles.Container>
  );
};
